import { MainMenuIcon } from '@model-framework/menu';
import { MainMenuBox } from '@model-framework/menu/MenuBox';
import { faAlignCenter } from '@fortawesome/free-solid-svg-icons';

type Props = {
  menuSize: number;
  isSelected: boolean;
  onClick(): void;
  text: string;
};

export const TextAlignMainMenu: React.FC<Props> = ({ menuSize, isSelected, onClick, text }: Props) => {
  return (
    <>
      <MainMenuBox isSelected={isSelected} menuSize={menuSize} onClick={onClick} text={text} />
      <MainMenuIcon icon={faAlignCenter} menuSize={menuSize} />
    </>
  );
};
